import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../../components/form/DynamicForm';
import { Form, Validators } from '../../../../components/form/DynamicFormTs';
import Http from '../../../../Http';

class Pagos extends FormComponent {
  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'cliente/pago', saveUrl: 'cliente/save', backUrl: '/Catalogo/Cliente/' + this.props.match.params.id + '/Pagos' },
      new Form([
        Form.Field('select', 'cliente_id_banco', 'Banco', '', [Validators.required], 6, []),
        Form.Field('text', 'cliente_numero_cuenta', 'Numero de Cuenta', '', [Validators.required], 6),        
        Form.Field('text', 'cliente_clabe', 'Clabe', '', [Validators.required], 6),
      ], ['Guardar']), this.formData
    )
    if (this.props.match.params.id) {
      this.LoadPreds(this.props.match.params.id);
    }
  }

  formData = async (form, ejecutivo = null) => {
    let Res = await Http.get(`banco/all`);
    if (!Res.error) {
      let newForm = Form.FieldOptions(form, 'cliente_id_banco', Res.data, 'id', 'banco_nombre');
      return newForm;
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Pagos)
